/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateDiscountPayload = {
    validUntil?: string | null;
    discountType?: UpdateDiscountPayload.discountType;
    value?: string;
    note?: string | null;
};
export namespace UpdateDiscountPayload {
    export enum discountType {
        PERCENTAGE = 'percentage',
        FIXED = 'fixed',
    }
}

